<template>
  <div class="card">
    <div class="card-content has-text-centered">
      <div v-if="!documentUploading">
        <b-field
          type="is-danger"
          :message="errorMessage"
        >
          <b-upload
            v-model="file"
            drag-drop
          >
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon
                    icon="upload"
                    size="is-large"
                  >
                  </b-icon>
                </p>
                <p>
                  {{ $t('components.signingSteps.documentUpload.fileUploadLabel') }}
                </p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <div v-if="file && !isEmpty(file)">
          <span
            class="tag"
            :class="isValidFileType ? 'is-tertiary' : 'is-danger'"
          >
            {{ file.name }}

            <button
              class="delete is-small"
              type="button"
              @click="deleteFile"
            >
            </button>
          </span>
        </div>
      </div>
      <div v-else>
        <p class="subtitle has-text-centered">
          {{ $t('components.signingSteps.documentUpload.loadingLabel') }}
        </p>

        <b-progress size="is-large" type="is-tertiary">
        </b-progress>
      </div>
    </div>

    <footer
      class="card-footer"
      v-if="file && isValidFileType && !documentUploading"
    >
      <a
        @click="uploadFile(file)"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.documentUpload.buttonLabel') }}

        <b-icon icon="upload">
        </b-icon>
      </a>
    </footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import { objectUtils } from '@/mixins/objectUtils'

export default {
  name: 'DocumentUpload',
  mixins: [objectUtils],
  data () {
    return {
      documentUploading: false,
      file: {},
      allowedFileTypes: [
        'application/pdf'
      ]
    }
  },
  computed: {
    isValidFileType () {
      return this.allowedFileTypes.includes(this.file.type)
    },
    errorMessage () {
      if (!this.file || this.isEmpty(this.file)) {
        return ''
      } else {
        return this.isValidFileType
          ? ''
          : this.$t('components.signingSteps.documentUpload.invalidFileTypeError')
      }
    }
  },
  methods: {
    ...mapActions([
      'uploadDocument'
    ]),
    deleteFile () {
      this.file = {}
    },
    uploadFile (file) {
      let formData = new FormData()

      formData.append('multipartFile', file)

      this.documentUploading = true

      this.uploadDocument(formData)
        .then(response => {
          this.$emit('documentUploaded')
        })
        .catch(error => {
          this.documentUploading = false
          // TODO: Temporary workaround for babel-transform-remove-console
          //       plugin not working.
          // eslint-disable-next-line
          console.error('POST /api/documents/sign failed with error: ', error.message)

          this.$buefy.toast.open({
            duration: 3500,
            message: this.$t('components.signingSteps.documentUpload.documentUploadFailedToast'),
            position: 'is-bottom',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>
